import React from 'react';
import '../../pages/UserProfilePage.css';

const Wishlist = () => {
    return (
        <div className="wishlist">
            <h2>Wishlist</h2>
            <p>Your favorite products will appear here.</p>
        </div>
    );
};

export default Wishlist;
